import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";

import { EQM2050_R01Dto } from "./Dto_EQM2050_R01";
import { EQM2050_R01Filter } from "./Store_EQM2050_R01";

const baseUrl = `${config.apiUrl}/EQM2050_R01`;

export const getEQM2050_R01List = async (option: string, params: Partial<EQM2050_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/${option}`
    return await getData<ResponseDto<EQM2050_R01Dto[]>>(url, {
        params: { 
            ...params,
            listLength: listLength ?? 0
        } as EQM2050_R01Filter
    });
}

export const getEQM2050_R01AllCount = async (params: Partial<EQM2050_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: { 
            ...params
        } as EQM2050_R01Filter
    });
}

export const postEQM2050_R01 = async (data: EQM2050_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await postData<EQM2050_R01Dto[], ResponseDto<EQM2050_R01Dto[]>>(url, data);
}

export const patchEQM2050_R01 = async (data: EQM2050_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await patchData<EQM2050_R01Dto[], ResponseDto<EQM2050_R01Dto[]>>(url, data);
}

export const disableEQM2050_R01 = async (data: string[]) => {
    const url = `${baseUrl}/disable`;
    return await patchData<string[], ResponseDto<any>>(url, data);
}

export const deleteEQM2050_R01 = async (orgCd: string) => {
    const url = `${baseUrl}/${orgCd}`;
    return await deleteData<ResponseDto<any>>(url);
}

export const downloadExcel_EQM2050_R01 = async (option: string, params: Partial<EQM2050_R01Filter>, listLength: number = 0) => {
    
    const url = `${baseUrl}/excel/${option}`

    return await getData<ResponseDto<string>>(url, {
        params: { 
            ...params,
            listLength: listLength ?? 0 
        } as EQM2050_R01Filter
    });
}

export interface EQM2050_R01PdfParams extends Partial<EQM2050_R01Filter> {
    inspectionDt?: string;
    industrialWater?: number;
    domesticWater?: number;
    electricalEnergy01?: number;
    electricalEnergy02?: number;
    electricalEnergy03?: number;
}

export const downloadPdf_EQM2050_R01 = async (
    formType: 'form18' | 'form7',
    params: EQM2050_R01PdfParams
) =>
    getData<Blob>(`${baseUrl}/pdf/${formType}`, {
        params,
        responseType: 'blob',
        headers: { Accept: 'application/pdf' },
    });